import { utagLinkCart, utagViewArtificialPageView } from 'features/tealium/';
import { setGenericEvent } from 'features/tealium/ga4/custom';

import CartBaseItemView from '../../baseViews/ItemView';
import PriceChangeNotificationViewTemplate from '../templates/PriceChangeNotificationViewTemplate';

const trackArtificialPageViewEvent = utagViewArtificialPageView();

const trackCartEvents = utagLinkCart();

const PriceChangeNotificationView = CartBaseItemView.extend({
	className: 'priceChangeNotificationView',
	JSXTemplate: PriceChangeNotificationViewTemplate,
	ui: {
		btnDismiss: '.btnDismiss'
	},
	events: {
		'click @ui.btnDismiss': 'dismissModal'
	},
	initialize () {

		this.listenTo(this.model, 'change:PriceChangeNotifications', () => {

			const PriceChangeNotifications = this.model.get('PriceChangeNotifications');
			if (PriceChangeNotifications && PriceChangeNotifications.length > 0) {

				this.render();

			}

		});

	},
	templateHelpers () {

		const helpers = {};
		const productItems = this.model.get('PriceChangeNotifications');

		_.each(productItems, (item) => {

			// GA event tracking for item price change
			if (window.utag) {

				const eventLabelValue = `Price Change - ${item.ShortSku} - ${window.utag.data.cart_id}`;

				if ([ 'none', 'consumer', 'professional' ].includes(window.utag_data.user_type.toLowerCase())) {

					trackCartEvents({
						eventAction: 'Error-Product',
						eventLabel: eventLabelValue
					});

				}

				if (window.utag_data.user_type.toLowerCase() === 'employee') {

					trackCartEvents({
						eventAction: 'Employee-Error-Product',
						eventLabel: eventLabelValue
					});

				}

				if (window.utag_data.user_type.toLowerCase() !== 'hospitality') {

					setGenericEvent({
						event_name: 'cart_product_error',
						error_message: eventLabelValue
					});

				}

			}

		});

		return helpers;

	},
	onAttach () {

		const PriceChangeNotifications = this.model.get('PriceChangeNotifications');
		if (PriceChangeNotifications && PriceChangeNotifications.length > 0) {

			$('body').lpModal({
				lpModalClass: 'lpModal--alt1',
				onInit: true,
				appendContentToForm: false,
				content: this.$el,
				height: 384,
				width: 542,
				openEvt: () => {

					setTimeout(() => {

						trackArtificialPageViewEvent({ pageName: 'Prices Changed' });

					}, 2000);

				},
				closeEvt: () => trackArtificialPageViewEvent({ pageName: '' })
			});

		}

	},
	dismissModal () {

		$('#lpModalClose').trigger('click');

	}
});

export default PriceChangeNotificationView;
